export const FROM = 87;
export const TO = 88;
export const DISTANCE_METERS = 175;
export const DISTANCE_FEETS = 176;
export const DISTANCE_TIME = 177;
export const PLACEHOLDER_SELECT_START = 55;
export const PLACEHOLDER_SELECT_DEST = 85;
export const QR_TITLE = 180;
export const EQUAL_ROUTE_NODES = 248;

export const DEFAULT_LANG = 'en';

export const TEMPLATE_DEFAULT = `<%= logo %>
    Welcome to <%= buildingName %>
    Please use the link below for directions to: <%= nodeToName %>
    <%= link %>
    Kind Regards

    <%= buildingName %>
    <%= buildingAddress %>`
